// extracted by mini-css-extract-plugin
module.exports = {"logoRU":"RegistrationLogo_logoRU__Szdps","logoKZ":"RegistrationLogo_logoKZ__PRqlV","logoUZ":"RegistrationLogo_logoUZ__XB1FD"};